export default __webpack_public_path__ + "static/GOTS_for_Totes-450c540745657b9abe90651b47cdbbea.svg";